import { render, staticRenderFns } from "./RatingList.vue?vue&type=template&id=6da6a739&scoped=true&"
import script from "./RatingList.vue?vue&type=script&lang=js&"
export * from "./RatingList.vue?vue&type=script&lang=js&"
import style0 from "./RatingList.vue?vue&type=style&index=0&id=6da6a739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6a739",
  null
  
)

export default component.exports